import { FC, useRef } from "react";
import { RichTextProps } from "/Models/Generated/RichTextProps";
import "./RichText.scss";
import { createSpreadableBem } from "/Helpers/createBem";
import { useScrollableTables } from "/Helpers/Hooks/useScrollableTables";

export type RichTextTheme =
  | "standard"
  | "footer"
  | "factssidebar"
  | "articlereferences"
  | "searchtips"
  | "searchtips-insight"
  | "cv";

export type RichTextExtensionProps = Partial<{
  theme: RichTextTheme;
  breakWord?: boolean;
}>;

interface RichTextComponentProps
  extends RichTextProps,
    RichTextExtensionProps {}

const RichText: FC<RichTextComponentProps> = ({
  html,
  theme = "standard",
  breakWord,
}) => {
  const richTextRef = useRef<HTMLDivElement>(null);

  useScrollableTables(richTextRef, {
    scrollerClass: "rich-text-react__table-scroller",
    canScrollLeftClass: "rich-text-react__table-wrapper--can-scroll-left",
    canScrollRightClass: "rich-text-react__table-wrapper--can-scroll-right",
  });

  const bem = createSpreadableBem("rich-text-react");

  return (
    <div
      ref={richTextRef}
      {...bem(
        "",
        "--no-extra-margins", //We can add a flag to disable this later if needed.
        {
          "--standard": theme === "standard",
          "--footer": theme === "footer",
          "--factssidebar": theme === "factssidebar",
          "--articlereferences": theme === "articlereferences",
          "--searchtips": theme === "searchtips",
          "--searchtips-insight": theme === "searchtips-insight",
          "--cv": theme === "cv",
          "--break-word": breakWord,
        }
      )}
      dangerouslySetInnerHTML={{ __html: html ?? "" }}
    />
  );
};

export default RichText;
